import { useState, useEffect } from 'react'
import * as db from '../../services/db'
import { setSoundsEnabled as setSoundsGlobal } from '../../services/sounds'

const SOUND_KEY = 'soundsEnabled'
const CELEBRATION_KEY = 'celebrationEnabled'
const CASH_LEARNING_KEY = 'cashLearningMode'

export function SettingsView() {
  const [soundsEnabled, setSoundsEnabled] = useState(true)
  const [celebrationEnabled, setCelebrationEnabled] = useState(true)
  const [cashLearningMode, setCashLearningMode] = useState(true)

  useEffect(() => {
    db.getSetting(SOUND_KEY).then((v) => {
      const on = v !== 'false'
      setSoundsEnabled(on)
      setSoundsGlobal(on)
    })
    db.getSetting(CELEBRATION_KEY).then((v) => setCelebrationEnabled(v !== 'false'))
    db.getSetting(CASH_LEARNING_KEY).then((v) => setCashLearningMode(v !== 'false'))
  }, [])

  const toggleSounds = async () => {
    const next = !soundsEnabled
    setSoundsEnabled(next)
    setSoundsGlobal(next)
    await db.setSetting(SOUND_KEY, next ? 'true' : 'false')
  }

  const toggleCelebration = async () => {
    const next = !celebrationEnabled
    setCelebrationEnabled(next)
    await db.setSetting(CELEBRATION_KEY, next ? 'true' : 'false')
  }

  const toggleCashLearning = async () => {
    const next = !cashLearningMode
    setCashLearningMode(next)
    await db.setSetting(CASH_LEARNING_KEY, next ? 'true' : 'false')
  }

  return (
    <>
      <h2 className="page-title">Settings</h2>
      <div className="settings-list">
        <label className="settings-row">
          <input
            type="checkbox"
            checked={soundsEnabled}
            onChange={toggleSounds}
            className="settings-checkbox"
            aria-describedby="sounds-desc"
          />
          <span>Scan & checkout sounds</span>
          <span id="sounds-desc" className="settings-desc">Beeps when you add an item or complete a purchase</span>
        </label>
        <label className="settings-row">
          <input
            type="checkbox"
            checked={celebrationEnabled}
            onChange={toggleCelebration}
            className="settings-checkbox"
            aria-describedby="celebration-desc"
          />
          <span>Celebration on checkout</span>
          <span id="celebration-desc" className="settings-desc">Confetti when purchase is complete</span>
        </label>
        <label className="settings-row">
          <input
            type="checkbox"
            checked={cashLearningMode}
            onChange={toggleCashLearning}
            className="settings-checkbox"
            aria-describedby="cash-learning-desc"
          />
          <span>Cash: Learning mode</span>
          <span id="cash-learning-desc" className="settings-desc">When on: kids count bills, coins, and change. When off: cash works like card (one tap to complete).</span>
        </label>
      </div>
    </>
  )
}
